<template>
  <div class="registerCardStyle">
    <UserBase
      title="新規アカウント情報の登録"
      :loginLink="false"
      :description="description"
    >
      <template #default>
        <v-row
          no-gutters
          :class="'pb-' + rowStyle.space.title"
          justify="center"
          align-content="center"
        >
          <v-col cols="10"> 氏名 <RequiredLabel /></v-col>
        </v-row>
        <v-row
          no-gutters
          :class="'pb-' + rowStyle.space.contents"
          justify="center"
          align-content="center"
        >
          <v-col cols="5">
            <v-text-field
              v-model="userInfo.lastName"
              placeholder="姓"
              outlined
              dense
              hide-details
              height="36"
              class="pr-2"
            >
            </v-text-field>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="userInfo.firstName"
              placeholder="名"
              outlined
              dense
              hide-details
              height="36"
              class="pl-2"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          :class="'pb-' + rowStyle.space.title"
          justify="center"
          align-content="center"
        >
          <v-col cols="10"> 会社名（または屋号） <RequiredLabel /></v-col>
        </v-row>
        <v-row
          no-gutters
          :class="'pb-' + rowStyle.space.contents"
          justify="center"
          align-content="center"
        >
          <v-col cols="10">
            <v-text-field
              v-model="userInfo.organization"
              placeholder="〇〇株式会社"
              outlined
              dense
              hide-details
              height="36"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          :class="'pb-' + rowStyle.space.title"
          justify="center"
          align-content="center"
        >
          <v-col cols="10"> 基準通貨 </v-col>
        </v-row>
        <v-row no-gutters justify="center" align-content="center">
          <v-col cols="10">
            <v-select
              v-model="currency.selected"
              item-text="name"
              item-value="currencyId"
              :items="currency.items"
              dense
              outlined
              return-object
              class="original-selectbox"
              hide-details
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row no-gutters class="py-8" justify="center" align-content="center">
          <v-col cols="10">
            <NormalButton
              text="登録してはじめる"
              height="50px"
              @click="execRegisterUserProfile"
            />
          </v-col>
        </v-row>
      </template>
    </UserBase>
  </div>
</template>
<script>
import { UserBase } from '@/components/layouts'

import { NormalButton, RequiredLabel } from '@/components/items'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    UserBase,
    NormalButton,
    RequiredLabel
  },
  data: () => {
    return {
      description: '発注書などで使用するために必要な情報を入力してください。',
      rowStyle: {
        space: {
          title: 2,
          contents: 3
        }
      },
      currency: {
        items: [],
        selected: {}
      },
      userInfo: {
        firstName: '',
        lastName: '',
        organization: ''
      }
    }
  },
  created() {
    this.currency.items = this.getCurrencyListFromState()

    if (this.currency.items.length > 0) {
      this.currency.selected = this.currency.items[0]
    }
  },
  methods: {
    ...mapActions('User', ['registerUserProfile']),
    ...mapGetters('Common', ['getCurrencyListFromState']),
    async execRegisterUserProfile() {
      const isSuccess = await this.registerUserProfile({
        firstName: this.userInfo.firstName,
        lastName: this.userInfo.lastName,
        organizationName: this.userInfo.organization,
        currencyId: this.currency.selected.currencyId
      })
      // ユーザ登録後はチュートリアルに遷移する
      if (isSuccess) {
        this.$router.push({ name: 'tutorial' }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .terms {
    font-size: 12px !important;
  }
}
</style>
